import { Instance, types } from "mobx-state-tree";

export const UploadInProgressWarningModel = types
  .model({
    isVisible: types.optional(types.boolean, false),
  })
  .actions((self) => ({
    cancel() {
      self.isVisible = false;
    },
    show() {
      self.isVisible = true;
    },
  }));

export type UploadInProgressWarning = Instance<typeof UploadInProgressWarningModel>;
